import axios from "../axios-auth";

export const shiftInfoService = {
    getShiftInfoList,
    getShiftInfosByShopId,
    saveShiftInfo,
    getShiftInfoDetail,

};

/*function getShiftInfosByStatus(status) {
  return axios.get("auth/shift-infos-by-status/" + status);
}*/

function getShiftInfosByShopId(shopId) {
    return axios.get("auth/shift-info-by-shopId/" + shopId);
}

function getShiftInfoList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let url = '/auth/shift-infos?page=' + page + '&size=' + size + '&sort=' + sortedBy;
    if (searchParams.name) {
        url += '&name=' + searchParams.name;
    }
    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.status) {
        url += '&status=' + searchParams.status;
    }
    return axios.get(url);
}

function saveShiftInfo(shiftInfo) {
    if (!shiftInfo.id) {
        // new shiftInfo
        return axios.post("/auth/shift-info", shiftInfo);
    } else {
        // edit
        return axios.put("/auth/shift-info", shiftInfo);
    }
}

function getShiftInfoDetail(id) {
    return axios.get('/auth/shift-info/' + id);
}